<footer class="main-footer">
    <div class="float-right d-none d-sm-block"><b>Version</b> 1.0</div>
    <strong>Copyright &copy; 2019-2020
        <a href="https://vnpt.com.vn/">VNPT</a>.</strong>
    All rights reserved.
</footer>